var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "tile is-parent pl-1" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("div", { staticClass: "columns is-flex is-align-items-center" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              _vm.entity
                ? _c("div", { staticClass: "field mb-0" }, [
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.modDesc,
                            expression: "entity.modDesc",
                          },
                        ],
                        staticClass: "input is-size-4 has-text-weight-semibold",
                        class: {
                          "is-danger":
                            _vm.$vv &&
                            _vm.$vv.entity &&
                            _vm.$vv.entity.modDesc &&
                            _vm.$vv.entity.modDesc.$error,
                        },
                        staticStyle: { "max-width": "26rem" },
                        attrs: {
                          type: "text",
                          placeholder: "FlexiQuote Module",
                        },
                        domProps: { value: _vm.entity.modDesc },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.entity,
                                "modDesc",
                                $event.target.value
                              )
                            },
                            _vm.onModDescChange,
                          ],
                        },
                      }),
                    ]),
                    _vm.$vv &&
                    _vm.$vv.entity &&
                    _vm.$vv.entity.modDesc &&
                    _vm.$vv.entity.modDesc.$error
                      ? _c("p", { staticClass: "help is-danger" }, [
                          _vm._v("Module description is required"),
                        ])
                      : _vm._e(),
                  ])
                : _c("span", { staticClass: "title" }, [
                    _vm._v("FlexiQuote Module"),
                  ]),
              _vm.entity && _vm.entity.isBase
                ? _c("span", { staticClass: "tag is-success ml-2" }, [
                    _vm._v("Base Module"),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("PermissionTree", {
                attrs: {
                  "permission-records": _vm.permissionRecords,
                  "disable-toggle-children": true,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }